import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { ObjectField } from '../models/project';

@Injectable()
export class ObjectFieldService {

  constructor(private http: HttpClient) {
  }

  get(): Observable<ObjectField[]> {
    return this.http.get<any>(`${environment.apiUrl}/object-fields`)
      .pipe(map(json => {
        return json.data.map(row => {
          return new ObjectField(row);
        });
      }));
  }

  create(data: { type: string, key: string, label: string }): Observable<ObjectField> {
    return this.http.post<any>(`${environment.apiUrl}/object-fields`, data)
      .pipe(map(json => {
        return new ObjectField(json);
      }));
  }

  update(field: ObjectField, data: { type: string, key: string, label: string }): Observable<ObjectField> {
    return this.http.put<any>(`${field.url}`, data)
      .pipe(map(json => {
        return new ObjectField(json);
      }));
  }

  destroy(field: ObjectField): Observable<void> {
    return this.http.delete<any>(`${field.url}`)
      .pipe(map(json => {
        return;
      }));
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/object-field.service.ts